<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="max-width: 90%">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline ps-2 pa-1">{{ $t("seasonalPage.createSeasonalHeadline") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-text-field
                      outline
                      v-model="model.day"
                      :rules="[rules.required]"
                      :label="$t('seasonalPage.day')"
                      type="date"
                    ></v-text-field>
                <div class="time-container">
                  <div class="time-left">
                    <!-- Left column content -->
                    <div>
                      <span>{{ $t("seasonalPage.from") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.start_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                  <div class="time-right">
                    <!-- Right column content -->
                    <div>
                      <span>{{ $t("seasonalPage.to") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.end_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                </div>

                <v-btn :loading="loading" block @click="createSeasonalTime" color="secondary" dark>{{ $t("seasonalPage.create") }}</v-btn>
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("seasonalPage.createPageTitle");
  },
  data: () => ({
    model: {
      day: "",
      start_time: "05:00",
      end_time: "09:00",
    },

    loading: false,
    form: false,
  }),

  computed: {
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("seasonalPage.invalidLength", { len }),
        required: (v) => !!v || this.$t("seasonalPage.fieldRequired"),
      };
    },
  },

  methods: {
    allowedMinutes: (v) => v == 15 || v == 30 || v == 45 || v == 0,
    createSeasonalTime() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        console.log(22)
        if (this.model.end_time <= this.model.start_time) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("seasonalPage.invalidHours"),
            "red"
          );
          this.loading = false;

          return;
        }
        this.axios
          .post(this.api.ACTIONS.SEASONAL_RESERVATIONS, {
            ...this.model,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("seasonalPage.createdSuccess"), "green");
            this.$router.push("/seasonal_reservations");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("seasonalPage.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      console.log(this.model);
      // }
    },
  },
};
</script>

<style scoped>
.time-container {
  display: flex;
}

.time-left,
.time-right {
  flex: 1;
  padding: 10px;
}
</style>
